import './button.scss';
import { useNavigate } from 'react-router-dom';

const CommonButton = ({ text, fontFamily, routePath, containerPage, onClickFunc, disabled }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (routePath)
      navigate(routePath, {state: { from: containerPage } });
    else onClickFunc();
  }

  return (
    <button onClick={handleClick} tabIndex="true" disabled={disabled}
      style={{ fontFamily: fontFamily, '--text-chars-count': text.length }}
      className='common-button background-transition-only'>
      {text}
    </button>
  );
};

export default CommonButton;